import React from 'react';

import { DateTime } from 'luxon';

import { Account__TermCommitment } from '@portal/schema';

import { Modal } from '../term_commitment/modal';
import { TermCommitmentAction, MessageType } from '../term_commitment/options';

const options = [
  {
    value: TermCommitmentAction.RemoveItems,
    label: 'Remove items from this appointment.',
  },
  {
    value: TermCommitmentAction.ContactCare,
    label: 'Contact an account manager to discuss my options.',
  },
];

export const TermCommitmentModal: React.FC<{
  termCommitment: Account__TermCommitment;
  scheduled: DateTime;
  onClose(): void;
}> = ({ termCommitment, scheduled, onClose }) => (
  <Modal
    messageType={MessageType.UpdatingItems}
    termCommitment={termCommitment}
    options={options}
    scheduled={scheduled}
    onClose={onClose}
  />
);
